import { render, staticRenderFns } from "./authPagesTemplate.vue?vue&type=template&id=7b33e8b4"
import script from "./authPagesTemplate.vue?vue&type=script&lang=js"
export * from "./authPagesTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports